import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Button } from "semantic-ui-react";
import { BackOfficeRoutes } from "@routes/urls";

const ViewDetailsButton = ({ patronId, userType }) => {
  // Capitalize first letter for display
  const displayUserType = userType
    ? userType.charAt(0).toUpperCase() + userType.slice(1)
    : "N/A";

  return (
    <Button
      as={Link}
      to={BackOfficeRoutes.patronDetailsFor(patronId)}
      compact
      data-test={patronId}
      fluid
    >
      {displayUserType}
    </Button>
  );
};

ViewDetailsButton.propTypes = {
  patronId: PropTypes.string.isRequired,
  userType: PropTypes.string,
};

ViewDetailsButton.defaultProps = {
  userType: null,
};

export default ViewDetailsButton;
